<div>
  <div class="row row-cols-1 row-cols-lg-2">
    <div class="col p-2 p-lg-4">
      @if (selectedMessage()?.id) {
        <div class="mb-2 d-lg-none">
          <button class="btn w-100 btn-outline-danger" (click)="onDelete()">
            Delete Pinned Message
          </button>
        </div>
      }

      <div class="row row-cols-2 mb-3">
        <div class="col">
          <button
            class="btn btn-lg w-100 btn-secondary"
            (click)="onCancelClick()"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-lg w-100 btn-success"
            [disabled]="
              !messageToBePinned?.trim()?.length ||
              !selectedUserListData?.length ||
              (messageToBePinned?.trim() ==
                selectedMessage()?.message?.trim() &&
                haveSameUserIdList &&
                !hasPinTillChanged)
            "
            (click)="onSaveUpdate()"
          >
            Save
          </button>
        </div>
      </div>

      <div class="mb-4">
        <textarea
          class="form-control"
          placeholder="Message"
          rows="12"
          wrap="hard"
          type="text"
          [(ngModel)]="messageToBePinned"
          id="messageField"
          autofocus
        ></textarea>
      </div>
      <div class="mb-4">
        <dd class="d-flex gap-2 align-items-center">
          @if (pinTill) {
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                value=""
                id="checkDefault"
                [checked]="pinTill"
                (change)="updatePinTill()"
              />
            </div>
            <div class="form-floating" [ngClass]="largeView ? 'w-50' : 'w-100'">
              <input
                type="date"
                class="form-control"
                placeholder="Show Until"
                [(ngModel)]="pinTill"
                [min]="today"
                (change)="onPinTillChange()"
              />
              <label>Show Until</label>
            </div>
          } @else {
            <button (click)="updatePinTill()" class="btn btn-danger px-5">
              Show Until
            </button>
          }
        </dd>
      </div>
    </div>

    <div class="col p-2 p-lg-4">
      <div class="ms-2">
        <div class="mb-2 fw-semibold">Recipients</div>
        <gtapp-select-users
          shownFrom="addEditPinnedMessage"
          [onSelectedUsersInput]="selectedUserListData"
          (onSelectUser)="onSelectUser($event)"
        ></gtapp-select-users>
      </div>
    </div>
  </div>
</div>
